import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/window-maximize': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416zM464 426v-234h-416v234c0 3.3 2.7 6 6 6h404c3.3 0 6-2.7 6-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/window-maximize.js
// module id = 1834
// module chunks = 0